<template>
  <div>
    <vue-html2pdf
      v-if="!only_graph"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1500"
      filename="bigfives"
      :pdf-quality="1"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="760px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <h1 class="center">Resultado Bigfive</h1>
          <BarChart
            :height="190"
            :chart-data="datacollection_bigfive"
          />
        </section>
        <div
          class="html2pdf__page-break"
          v-if="amount > 50"
        />
        <template
          class="pdf-item"
          v-for="(result, index) in results_translate"
        >
          <section
            :key="index + 'title'"
            class="pdf-item f13"
          >
            <p
              style="color: #8668f2"
              class="f18 mt-4 mb-0 pb-0"
            >
              <strong>{{ result.title }}</strong>
            </p>
          </section>
          <section
            :key="index + 'result'"
            class="pdf-item f13"
          >
            <p
              style="color: #000"
              class="f15 mb-0 pb-0"
            >
              score: {{ result.score }} |
              {{ scoreTextTranslate[result.scoreText] }}
            </p>
          </section>

          <section
            :key="index + 'short'"
            class="pdf-item f13"
          >
            <p
              style="color: #000"
              class="f15 mb-0 pb-0"
            >
              {{ result.shortDescription }}
            </p>
          </section>

          <section
            :key="index + 'text'"
            class="pdf-item f13"
          >
            <p
              style="color: #000"
              class="ml-4"
            >
              {{ result.text }}
            </p>
          </section>
          <section
            :key="index + 'grap' + result.scoreText"
            class="pdf-item f13"
          >
            <BarChart
              :height="190"
              v-if="result.facets.length"
              :chart-data="calcFacets(result.facets)"
            />
          </section>

          <template
            class="pdf-item ml-4"
            v-for="(facets, index_key) in result.facets"
          >
            <section
              :key="index_key + ' ' + facets.title"
              class="pdf-item f13"
            >
              <p
                style="color: #01b9f7"
                class="mt-3 mb-0"
              >{{ facets.title }}</p>
              <span style="color: #000">score: {{ facets.score }} |
                {{ scoreTextTranslate[facets.scoreText] }}</span>
              <p style="color: #000">
                {{ facets.text }}
              </p>
            </section>
          </template>
          <div
            v-if="amount > 50"
            class="html2pdf__page-break"
            :key="index_key + 'break'"
          />
        </template>
      </section>
    </vue-html2pdf>
    <button
      v-if="valid && !load && !only_graph"
      type="button"
      class="btn mt-3 mb-3 btn-primary"
      @click="generateReport"
    >
      Download PDF
    </button>
    <div v-if="load">
      <div
        class="spinner-border text-light"
        role="status"
      >
        <span class="sr-only"></span>
      </div>
    </div>
    <div 
      v-if="!valid && !load && !only_graph"
      class="bg-purple color-white"
    >
      <h2 class="label-bold pt-3 pb-3">
        CANDIDATO NÃO PREENCHEU O TESTE BIGFIVE
      </h2>
    </div>
    <div 
      v-if="!valid && !load && only_graph"
      class="bg-purple color-white"
    >
      <p 
        v-if="is_limited"
        class="label-bold pl-3 pt-3 pb-3"
      >
        BIG5 NÃO FOI PREENCHIDO
      </p>
      <p
        v-else
        class="label-bold pl-3 pt-3 pb-3"
      >
        CANDIDATO(A) NÃO PREENCHEU O TESTE BIGFIVE
      </p>
    </div>
    <div
      v-if="valid && !load"
      class="container"
    >
      <div v-if="!only_graph">
        <h1 class="pl-3 label-bold pt-3">RESULTADO BIGFIVE</h1>
        <BarChart :chart-data="datacollection_bigfive" />
      </div>

      <div v-if="only_graph">
        <p class="label-bold pt-3">RESULTADO BIG FIVE</p>
        <BarChart
          :height="190"
          :chart-data="datacollection_bigfive"
        />
      </div>

      <div v-if="!only_graph">
        <div
          v-for="(result, index) in results_translate"
          :key="index"
        >
          <p
            style="color: #8668f2"
            class="f18 mt-4 mb-0 pb-0"
          >
            <strong>{{ result.title }}</strong>
          </p>
          <p>
            score: {{ result.score }} |
            {{ scoreTextTranslate[result.scoreText] }}
          </p>
          <p class="ml-4">
            {{ result.shortDescription }}
          </p>

          <p class="ml-4">
            {{ result.text }}
          </p>
          <BarChart
            v-if="result.facets.length"
            :chart-data="calcFacets(result.facets)"
          />
          <div
            class="ml-4"
            v-for="(facets, index_key) in result.facets"
            :key="index_key"
          >
            <p
              style="color: #01b9f7"
              class="mt-3 mb-0"
            >{{ facets.title }}</p>
            <span>score: {{ facets.score }} |
              {{ scoreTextTranslate[facets.scoreText] }}</span>
            <p>
              {{ facets.text }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <button
      v-if="!no_next"
      class="btn btn-success right"
      @click="gotoFinal"
    >
      Próxima etapa
      <font-awesome-icon
        class="ml-2"
        icon="chevron-right"
      />
    </button>
  </div>
</template>

<script>
import BarChart from "components/BarChart.js";
import VueHtml2pdf from "vue-html2pdf";
export default {
  components: { BarChart, VueHtml2pdf },
  props: ["candidate_uid", "no_next", "only_graph", "account_uid", "is_limited"],
  data: () => ({
    datacollection_bigfive: {
      label: [],
    },
    valid: false,
    load: false,
    uid_local: "",
    amount: 50,
    bigfive_candidate: {},
    results_translate: [],
    scoreTextTranslate: {
      low: "Baixo",
      high: "Alto",
      neutral: "Neutro",
    },
  }),
  watch: {
    candidate_uid: function (new_obj, old_obj) {
      this.uid_local = this.candidate_uid;
      this.find();
    },
  },
  mounted() {
    this.uid_local = this.candidate_uid;

    if (this.candidate_uid) {
      this.load = true;
      this.find();
    }
  },
  methods: {
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf();
    },
    gotoFinal() {
      eventBus.$emit("gotoFinal", true);
    },
    find() {
      let url = "/bigfive_candidates/" + this.uid_local;
      if (this.account_uid || top.location.href.indexOf("?account_uid=") > -1) {
        url += "?account_uid=";
        url +=
          this.account_uid ||
          top.location.href.slice(
            top.location.href.indexOf("?account_uid=") + 13
          );
      }

      axios.get(url).then((response) => {
        if (response.data.status == false) {
          this.valid = false;
          this.load = false;

          if (response.data.bigfive) {
            this.amount = response.data.bigfive.amount_itens;
          }
          return;
        }
        this.bigfive_candidate = response.data;
        this.valid = true;
        this.load = false;
        this.setup();
        return;
      });
    },
    setup() {
      const calculateScore = require("@alheimsins/bigfive-calculate-score");
      const getResult = require("@alheimsins/b5-result-text");
      let result = {
        lang: "pt-br",
        totalQuestions: this.bigfive_candidate.answers.length,
        answers: this.bigfive_candidate.answers,
      };

      let scores = calculateScore(result);
      this.results_translate = getResult({ scores: scores, lang: "pt-br" });
      let label = [];
      let dataset_data = [];
      for (let index in this.results_translate) {
        label.push(this.results_translate[index].title);
        dataset_data.push(this.results_translate[index].score);
      }

      this.datacollection_bigfive = {
        // Data for the y-axis of the chart
        labels: label,
        legend: {
          display: false,
          labels: {
            defaultFontSize: 10,
          },
        },
        width: "100%",
        height: "150px",
        datasets: [
          {
            label: "",
            backgroundColor: [
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
            ],
            // Data for the x-axis of the chart
            data: dataset_data,
          },
        ],
      };
    },
    calcFacets(facets) {
      let label = [];
      let dataset_data = [];
      for (let index in facets) {
        label.push(facets[index].title);
        dataset_data.push(facets[index].score);
      }

      return {
        labels: label,
        legend: {
          display: false,
        },
        datasets: [
          {
            label: "",
            backgroundColor: [
              "#008FFB",
              "#00E396",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#008FFB",
              "#00E396",
            ],
            data: dataset_data,
          },
        ],
      };
    },
  },
};
</script>
